export default "__VITE_ASSET__KUxnyrqG__"